const toggleBigMenu = function() {
  let open = false;
  const body = document.querySelector("body");
  const button = document.querySelector(".js-big-menu");
  const navBig = document.querySelector(".nav__big");
  const navBigAnchors = document.querySelectorAll(".nav__big a");

  /*
  // navBigAnchors.forEach(element =>
  //   element.setAttribute("tabindex", open ? 0 : -1)
  // );
  */
  for (let i = 0; i < navBigAnchors.length; ++i) {
    navBigAnchors[i].tabindex = open ? 0 : -1;
  }

  const clickHandler = event => {
    event.preventDefault();

    button.classList.toggle("button__navigation--open", !open);
    /*
    // navBigAnchors.forEach(element =>
    //   element.setAttribute("tabindex", !open ? 0 : -1)
    // );
    */
    for (let i = 0; i < navBigAnchors.length; ++i) {
      navBigAnchors[i].tabindex = !open ? 0 : -1;
    }
    navBig.setAttribute("aria-hidden", open);

    body.classList.toggle("showing-big-navigation", !open);
    navBig.classList.toggle("nav__big--open", !open);

    open = !open;
  };

  button.addEventListener("click", clickHandler, false);
};

const Navigation = function() {
  const body = document.querySelector("body");
  const { pathname } = window.location;

  toggleBigMenu();

  this.directory = {
    "art-programs": [
      "art-programs",
      "exhibitions",
      "exhibition",
      "programs",
      "community",
      "collection",
      "channel"
    ],
    research: ["arc", "publications", "research"],
    visit: ["visit", "calendar", "support"]
  };

  let segments = pathname.split("/");
  let pattern = new RegExp(segments[1]);

  let active = Object.keys(this.directory).filter(parent =>
    pattern.test(this.directory[parent])
  );

  if (!!active.length) {
    body.classList.add(active);
  }
};

module.exports = Navigation;
